import { commentPicks } from "@/mocks/guaData";

export default function CommentTalk() {
  return (
    <section id="comment-talk" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <p className="mb-1.5 text-xs font-bold uppercase tracking-widest text-accent-700">Buzz · 热议现场</p>
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              评论区风向，比瓜本身还精彩
            </h2>
          </div>
          <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-xs text-foreground-500 md:inline-flex">
            <i className="ri-fire-fill text-primary-500" /> 今日热议 3.2万条
          </span>
        </div>

        {/* 评论留言框（静态展示，不可真实提交） */}
        <div className="mb-6 flex items-start gap-3 rounded-lg border border-background-200/70 bg-background-100/60 p-4">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
            你
          </span>
          <div className="flex-1">
            <input
              type="text"
              aria-label="写下你的看法"
              placeholder="我也来吃两口，说说你站哪边…"
              className="w-full rounded-md border border-background-200 bg-background-50 px-3 py-2 text-sm text-foreground-900 outline-none transition placeholder:text-foreground-400 focus:border-primary-300 focus:ring-2 focus:ring-primary-200/50"
            />
            <div className="mt-2 flex items-center justify-between">
              <p className="text-xs text-foreground-400">理性吃瓜 · 友善交流</p>
              <button
                type="button"
                className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-1.5 text-xs font-semibold text-background-50 transition hover:bg-primary-600"
              >
                发送评论
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {commentPicks.map((c) => (
            <article
              key={c.user}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-100/50 p-5"
            >
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2.5">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-200 text-sm font-bold text-secondary-800">
                    {c.user.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{c.user}</p>
                    <span className="text-[11px] text-foreground-400">{c.badge}</span>
                  </div>
                </div>
                {c.hot && (
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-bold text-primary-700">
                    <i className="ri-fire-fill" /> 高赞
                  </span>
                )}
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">“{c.text}”</p>
              <div className="mt-3 flex items-center gap-4 border-t border-background-200/60 pt-3 text-xs text-foreground-500">
                <button
                  type="button"
                  className="inline-flex cursor-pointer items-center gap-1 transition hover:text-primary-600"
                >
                  <i className="ri-heart-3-line" /> {c.likes.toLocaleString()}
                </button>
                <button type="button" className="inline-flex cursor-pointer items-center gap-1 transition hover:text-primary-600">
                  <i className="ri-chat-1-line" /> 回复
                </button>
                <span className="ml-auto inline-flex items-center gap-1">
                  <i className="ri-share-line" /> 分享
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}